import { range } from 'lodash'

export const getYearsList = (startDate, endDate) => {
  const from = startDate.get('year')
  const to = endDate.get('year') + 1
  return range(from, to)
}
